import { Button, Card, Row, Col, Image, Descriptions, Space, Tag } from "antd";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { hostname } from "../hooks/useEndeavour";
import axios from "axios";
import { timestampToLocalTime } from "anka-endeavour";
import DataTable from "../components/DataTable";
import { Link } from "react-router-dom";
import UserContactDrawer from "../components/UserContactDrawer";
import { useRef } from "react";
import { BellOutlined } from "@ant-design/icons";
import { useState } from "react";
import Status from "../components/Status";

export default function CampaignPage() {
  const [forceUpdate, setForceUpdate] = useState(0);
  const { campaign_id } = useParams();
  const drawerRef = useRef();
  const query = useQuery({
    queryKey: ["current_campaign", campaign_id],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/campaign/${campaign_id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          return res.data.payload[0];
        });
    },
  });

  const rulesQuery = useQuery({
    queryKey: ["campaign_rules"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/campaign/rule`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => res.data.payload.data || []);
    },
  });

  const getRuleNames = (rulesId) => {
    if (!rulesId || !rulesQuery.data) return [];
    return rulesId.map((id) => {
      const rule = rulesQuery.data.find((r) => r.id === id);
      return rule ? { id: rule.id, name: rule.name } : { id, name: id };
    });
  };

  const getRuleGroups = (rulesId) => {
    if (!rulesId || !rulesQuery.data) return [];
    
    const hasNestedArray = rulesId.some((item) => Array.isArray(item));
    
    if (hasNestedArray) {
      return rulesId.map((group) => {
        const groupArray = Array.isArray(group) ? group : [group];
        const names = groupArray.map((id) => {
          const rule = rulesQuery.data.find((r) => r.id === id);
          return rule ? rule.name : id;
        });
        return names.join(" AND ");
      });
    } else {
      return rulesId.map((id) => {
        const rule = rulesQuery.data.find((r) => r.id === id);
        return rule ? rule.name : id;
      });
    }
  };

  const ruleGroups = query.data?.rules_id ? getRuleGroups(query.data.rules_id) : null;

  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/campaign/${campaign_id}/approve`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          onUpdateFeeGroup();

          setLoading(false);
        });
    },
  });

  const onClickContact = (data) => {
    drawerRef.current.openDrawer(data);
  };
  const onUpdateFeeGroup = () => {
    setForceUpdate(forceUpdate + 1);
  };
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12}>
        <Card title="Campaign Details" style={{ height: "100%" }}>
          <Descriptions column={1}>
            <Descriptions.Item label="Name">{query.data?.name}</Descriptions.Item>
            <Descriptions.Item label="Type">{query.data?.type}</Descriptions.Item>
            <Descriptions.Item label="Description">{query.data?.description}</Descriptions.Item>
            <Descriptions.Item label="Start Date">{timestampToLocalTime(query.data?.start_at)}</Descriptions.Item>
            <Descriptions.Item label="Expired Date">{timestampToLocalTime(query.data?.expired_at)}</Descriptions.Item>
            <Descriptions.Item label="Rules">
              {query.data?.rules?.map((rule) => (
                <Tag key={rule.id} color="#c8a55a" style={{ marginBottom: 4 }}>
                  {rule.name}
                </Tag>
              ))}
              {!query.data?.rules && ruleGroups?.map((groupName, index) => (
                <Tag key={index} color="#c8a55a" style={{ marginBottom: 4 }}>
                  {groupName}
                </Tag>
              ))}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col xs={24} md={12}>
        <Card title="Campaign Banner">
          {/* <Descriptions>
            <Descriptions.Item label="Banner"> */}
          <Image src={query.data?.banner_url} style={{ height: "240px" }} />
          {/* </Descriptions.Item>
          </Descriptions> */}
        </Card>
      </Col>
      <Col span={24}>
        <UserContactDrawer ref={drawerRef} onChange={onUpdateFeeGroup} />
        <DataTable
          uri={`${hostname}/pa-alliance/campaign/${campaign_id}/user`}
          ForceUpdate={forceUpdate}
          name="CampaignUsers"
          tableColumns={[
            {
              title: "User",
              render: (data) => {
                return <Link to={`/users/${data.user_id}`}>{data.user_email}</Link>;
              },
            },
            {
              title: "Spending Over $100k",
              align: "center",
              render: (data) => {
                let status = "no";
                if (data.over1m) {
                  status = "yes";
                }
                return <Status value={status} />;
              },
            },
            {
              title: "Campaign Status",
              align: "center",
              render: (data) => {
                return <Status value={data.status} />;
              },
            },
            {
              title: "Created Date",
              render: (data) => {
                return timestampToLocalTime(data.created_at);
              },
            },
            {
              title: "Updated Date",
              render: (data) => {
                return timestampToLocalTime(data.updated_at);
              },
            },
            {
              title: "Action",
              render: (data) => {
                return (
                  <Space>
                    <Button type="primary" icon={<BellOutlined />} onClick={() => onClickContact(data.user_id)}>
                      Contacted User
                    </Button>
                    <Button type="primary" icon={<BellOutlined />} onClick={() => submit.mutate({ user_id: data.user_id })}>
                      Approve
                    </Button>
                  </Space>
                );
              },
            },
          ]}
        />
      </Col>
    </Row>
  );
}
